import Game from 'Game';
import { PlayerActions } from 'State/Player/PlayerActions';

/**
 * Prompt shortcut creation in foreground - game continues to preload in the background.
 */
export async function promptCreateShortcut() {
    const canCreateShortcut = await Game.sdk.canCreateShortcut().catch(console.warn);

    if (canCreateShortcut) {
        try {
            await Game.sdk.createShortcut();
            PlayerActions.setCreatedShortcut();
            console.log('Shortcut created');
        } catch (e) {
            console.log('Shortcut failed to create');
        }
    }
}
